// extracted by mini-css-extract-plugin
module.exports = {"image":"MapImage_image__15pim","small":"MapImage_small__mM50W","container-map":"MapImage_container-map__34hmK","map":"MapImage_map__2lY1g","map-small":"MapImage_map-small__2hKwN"};